<app-sidebar 
  [menuItems]="menuItems" 
  [callToAction]="callToAction"
  [footerItems]="footerItems"
  title="Admin">
</app-sidebar>



